var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.9,
    height: 19.5,
    viewBox: "0 0 15.9 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8666689_file_text_icon",
    "data-name": "8666689_file_text_icon",
    transform: "translate(-3.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49061",
    "data-name": "Path 49061",
    d: "M13,2H5.8A1.8,1.8,0,0,0,4,3.8V18.2A1.8,1.8,0,0,0,5.8,20H16.6a1.8,1.8,0,0,0,1.8-1.8V7.4Z",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49062",
    "data-name": "Path 49062",
    d: "M14,2V7.4h5.4",
    transform: "translate(-1)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 7.2,
    transform: "translate(7.6 11.9)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 7.2,
    transform: "translate(7.6 15.5)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49063",
    "data-name": "Path 49063",
    d: "M9.8,9H8",
    transform: "translate(-0.4 -0.7)",
    fill: "none",
    stroke: "#9c9baa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.8a9b5c7154d81eeeebe92efe915d8cbe.svg";
export { ForwardRef as ReactComponent };